import React from 'react';
import PropTypes from 'prop-types';


const todos=['1st todo','2nd todo', '3rd todo', 'Santhosh Todo']

const learning_27_05_2025 = () => (

    <div>
      
    learning_27_05_2025 Component
      <h1>My Todos</h1>
      <h2>Expensive Calculation
       {todos.map((todo, index) => {
          return <p key={index}>{todo}</p>;
        })}

      </h2>
    </div>
);

learning_27_05_2025.propTypes = {};

learning_27_05_2025.defaultProps = {};

export default learning_27_05_2025;
